interface SectionHeadingProps {
  overline: string;
  title: string;
  description: string;
}

const SectionHeading = ({ overline, title, description }: SectionHeadingProps) => {
  return (
    <div className="section-heading">
      <span>{overline}</span>
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
};

export default SectionHeading;
